export const LOADING_LOCAL = 'LOADING_LOCAL';
export const GET_LOCAL = 'GET_LOCAL';

